import React from "react";
import { motion } from "framer-motion";
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import SectionHeading from "@/components/SectionHeading";
import { useTranslation } from "react-i18next";

const FaqSection = () => {
  const { t } = useTranslation();
  
  const faqs = [
    {
      question: t('faq.questions.q1', "What is MysteryAct?"),
      answer: t('faq.answers.a1', "MysteryAct is an immersive social deduction experience blending storytelling, role-playing, and mystery-solving, where players take on unique character roles and work together to solve mysteries.")
    },
    {
      question: t('faq.questions.q2', "How do I play online?"),
      answer: t('faq.answers.a2', "To play online, simply create an account, browse available mysteries, and join a scheduled game or start your own. You can invite friends or be matched with other players.")
    },
    {
      question: t('faq.questions.q3', "Can I host my own in-person games?"),
      answer: t('faq.answers.a3', "Yes! You can purchase physical game kits or download printable materials to host your own in-person MysteryAct games at home or at a venue.")
    },
    {
      question: t('faq.questions.q4', "What's the difference between online and offline play?"),
      answer: t('faq.answers.a4', "Online play allows you to connect with players globally through our digital platform, while offline play involves physical meetings at homes or dedicated venues for face-to-face interaction.")
    },
    {
      question: t('faq.questions.q5', "Can I create my own mystery scenarios?"),
      answer: t('faq.answers.a5', "Absolutely! Our creator platform allows you to design, publish, and even monetize your own mystery scenarios. Visit our Author section to learn more.")
    }
  ];
  
  return (
    <section className="py-20 bg-black relative overflow-hidden mb-16">
      <div className="absolute inset-0 opacity-20 bg-grid-white/5"></div>
      <div className="container mx-auto px-6 relative z-10">
        <SectionHeading
          preTitle="FAQ"
          title={t('faq.title', "Frequently Asked Questions")}
          description={t('faq.description', "Everything you need to know about MysteryAct games")}
          centered
          showPreTitle={false}
        />
        
        <div className="max-w-3xl mx-auto mt-12">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <AccordionItem 
                  value={`item-${index}`} 
                  className="border dark:border-white/10 rounded-lg px-6 py-2 bg-black/50 backdrop-blur-sm"
                >
                  <AccordionTrigger className="text-left font-medium py-4 hover:no-underline text-white data-[state=open]:text-anzir">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-white pb-4 text-[14px] leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
